import { filterFlightList } from "../actions/flightAction";

export const filterResult = (
  flightList,
  selectedAirlines,
  selectedDepartureDates,
  selectedArrivalDates,
  minPrice,
  maxPrice,
  selectedStops,
  dispatch
) => {
  const checkTimeRange = (timeArr, OriginDest, IsDept, IsMulticity) => {
    var timeMatch = false;
    timeArr.forEach((v, i) => {
      var Dest = OriginDest[0];
      if (IsMulticity) Dest = OriginDest[OriginDest.length - 1];
      var tripTm = new Date(
        IsDept ? OriginDest[0].DepartureDateTime : Dest.ArrivalDateTime
      );
      var fromTm = new Date(tripTm.toLocaleDateString() + " " + v.From);
      var toTm = new Date(tripTm.toLocaleDateString() + " " + v.To);
      if (tripTm >= fromTm && tripTm <= toTm) {
        timeMatch = true;
        return false; // break loop
      }
    });
    return timeMatch;
  };
  const CheckStops = (OriginDest) => {
    var hasStops = true;
    OriginDest.forEach((v, i) => {
      if (selectedStops.indexOf(v.FlightDetails.length - 1) < 0) {
        hasStops = false;
        return false;
      }
    });
    return hasStops;
  };
  var filterResults = [];
  var minprice = minPrice;
  var maxprice = maxPrice;
  var stops = selectedStops;
  flightList.forEach((flight) => {
    if (
      selectedAirlines.length === 0 ||
      selectedAirlines.find(
        (airline) => airline.FlightCode === flight.ValidatingCarrier
      )
    ) {
      if (
        minprice <= flight.FareOptions[0].GTotalFare &&
        flight.FareOptions[0].GTotalFare <= maxprice
      ) {
        if (stops.length === 0 || CheckStops(flight.OriginDest)) {
          if (
            selectedDepartureDates.length === 0 ||
            checkTimeRange(
              selectedDepartureDates,
              flight.OriginDest,
              true,
              true
            )
          ) {
            if (
              selectedArrivalDates.length === 0 ||
              checkTimeRange(
                selectedArrivalDates,
                flight.OriginDest,
                false,
                false
              )
            ) {
              filterResults.push(flight);
            }
          }
        }
      }
    }
  });

  dispatch(filterFlightList(filterResults));
};
